import {UsualConditionsDTO} from "@app/core/payment-method/application/usual-conditions-dto";

export class UsualConditionsDTOMapper {

    private static readonly KEY = {
        PAYMENT_CONDITIONS_DESCRIPTION: 'conditionsDescription',
        PAYMENT_INSTRUMENT_DESCRIPTION: 'instrumentDescription',
    }

    map(data: Record<string, any>): UsualConditionsDTO {
        return new UsualConditionsDTO({
            conditionsDescription: data[UsualConditionsDTOMapper.KEY.PAYMENT_CONDITIONS_DESCRIPTION],
            instrumentDescription: data[UsualConditionsDTOMapper.KEY.PAYMENT_INSTRUMENT_DESCRIPTION],
        })
    }

}